import { render, staticRenderFns } from "./FactoryProductSaleTable.vue?vue&type=template&id=d75d3cc4&scoped=true&"
import script from "./FactoryProductSaleTable.vue?vue&type=script&lang=js&"
export * from "./FactoryProductSaleTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75d3cc4",
  null
  
)

export default component.exports